//@ts-nocheck
//@ts-ignore
/* eslint-disable */
import React, { useContext } from 'react';
import './styles.scss';
import { CheckContext } from './context';
import cn from 'classnames';
import { Text } from '../../typography/Text/Text';

interface OptionProps {
  children: React.ReactNode;
  value: string | number | boolean;
  className?: string;
}

export const Option: React.FC<OptionProps> = ({ children, value, className }) => {
  const { handleChange, currentValue } = useContext(CheckContext);
  const isActive = currentValue === value;

  return (
    <div
      className={cn('option', { active: isActive }, className)
      }
      onClick={() => handleChange(value)}
    >
      <Text semibold className='option-text'>
        {children}
      </Text>
    </div>
  );
};
